<div>
    <canvas id="stacked-chart"></canvas>
</div>

<script>
    import {Bar} from "vue-chartjs";
    // import Chart from "chart.js";
    // import ChartDataLabels from 'chartjs-plugin-datalabels';

    export default {
        name: 'chart_2_1',
        extends: Bar,
        data(){
            return {
                chartOptions1 : {
                    title: {
                        display: false,
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                padding: 20
                            },
                            stacked: true,
                            scaleLabel: {
                                display: false,
                                labelString: 'จำนวน',
                                font: {
                                    family : 'Prompt'
                                }
                            },
                        }],
                        xAxes: [ {
                            // stacked: true,
                            categoryPercentage: 0.5,
                            barPercentage: 1,
                            gridLines: {
                                color: "rgba(0, 0, 0, 0)",
                            },
                        }],
                    },
                    legend: {
                        display: true,
                        position: "bottom"
                    },
                    responsive: true,
                    maintainAspectRatio: false
                },
                chartData1: {
                    labels: ['ต่ำกว่า 15 ปี','15 ปี - ไม่เกิน 18 ปี','18 ปีขึ้นไป'],
                },
            }
        },
        component: {
        },
        props: ["year"],
        mounted() {
            this.$store.dispatch('dashboard/chart_2_1',this.year).then(res=>{
                console.log(res.data.data)
                this.chartData1.datasets = [
                    {
                        type: 'bar',
                        label: 'หญิง',
                        backgroundColor: 'rgba(132, 169, 242, 1)',
                        data : res.data.data
                    }
                ];
                this.renderChart( this.chartData1, this.chartOptions1);
            })
        },
        watch: {
            year: function(newVal) {
                this.$store.dispatch('dashboard/chart_2_1',newVal).then(res=>{
                    this.chartData1.datasets = [
                        {
                            type: 'bar',
                            label: 'หญิง',
                            backgroundColor: 'rgba(132, 169, 242, 1)',
                            data : res.data.data
                        }
                    ];
                    this.renderChart( this.chartData1, this.chartOptions1);
                })
            }
        },
        methods:{
        }
    }
</script>
